enum CategoryType {
  STANDARD = 'STANDARD',
  PIZZA = 'PIZZA',
  PIE = 'PIE',
  LASAGNA = 'LASAGNA',
}
export default CategoryType;
